import {LOAD_DEPENDS_ON_QUESTIONS_SUCCESS} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_DEPENDS_ON_QUESTIONS_SUCCESS:
            return action.payload;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/DependsOnQuestionsReducer.js